import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoginComponent} from './login.component';
import {LoginRoutingModule} from './login.routing.module';
import {TranslateModule} from '@ngx-translate/core';
import {MaterialModule} from '../material-module';
// import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
// import {NumberCommaDirective} from "../shared/services/number-comma.directive";

@NgModule({
  imports: [
    LoginRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MaterialModule,
    // InternationalPhoneNumberModule,

  ],
  declarations: [
    LoginComponent,
    // NumberCommaDirective

  ]
})
export class LoginModule {

}
